import {useEffect, useState} from 'react';

const useShowTimer = () => {
  const [isVisible, setIsVisible] = useState(false);

  const onClose = () => {
    setIsVisible(false);
    localStorage.setItem('showTimer', 'false');
  };

  useEffect(() => {
    if (
      !localStorage.getItem('showTimer') ||
      localStorage.getItem('showTimer') !== 'false'
    ) {
      setIsVisible(true);
    }
  }, []);

  return {
    isVisible,
    onClose,
  };
};

export default useShowTimer;
